// extracted by mini-css-extract-plugin
export default {"Card":"HorizontalCard_Card__5Aths","Image":"HorizontalCard_Image__9cRCg","Content":"HorizontalCard_Content__mt2Hf"};